import { Grid, Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from '@wordpress/element';
import { API } from '../API';
import ComerciosItem from '../ComerciosItem';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';

function SliderComerciosGrid({ displaySearchForm, perSlide }) {

  const apiEntidades = new API();
  const defaultArgs = {
    posts_per_page: 99,
  }

  const [totalEntidades, setTotalEntidades] = useState(0);
  const [originalEntidades, setOriginalEntidades] = useState([]);
  const [entidadesQuery, setEntidadesQuery] = useState();
  const [allEntidades, setAllEntidades] = useState([]);
  const searchEntidades = (event) => {

    event.preventDefault();

    if (!entidadesQuery) {
      setTotalEntidades(originalEntidades.length);
      setAllEntidades(originalEntidades);
      return;
    }

    const searchQuery = { ...defaultArgs, search: entidadesQuery };

    apiEntidades.loadContent(searchQuery).then(response => {
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data)
    });

  }

  useEffect(() => {

    const query = {
      posts_per_page: 99,
    };

    apiEntidades.loadContent(query).then(response => {
      setOriginalEntidades(response.data);
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data);
    });

  }, []);

  return (
    <>

      <Swiper
        className={displaySearchForm === 'false' ? 'mt-2' : ''}
        grid={{
          fill: 'row',
          rows: 2, // Default rows
        }}
        modules={[Grid, Pagination, A11y]}
        spaceBetween={32}
        slidesPerView={2} // Default slides per view
        freeMode={true}
        pagination={{
          clickable: true
        }}
        scrollbar={{ draggable: true }}
        breakpoints={{
          640: {
            slidesPerView: 2,
            grid: {
              rows: 2,
            },
          },
          768: {
            slidesPerView: 3,
            grid: {
              rows: 3,
            },
          },
          1024: {
            slidesPerView: 4,
            grid: {
              rows: 4,
            },
          },
        }}
      >
        {allEntidades.map(item => {
          return (
            <SwiperSlide key={item.id}>
              <ComerciosItem id={item.id} title={item.title} logo={item.logo} permalink={item.link} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
}

export default SliderComerciosGrid;